/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Solid_Bright_Haddock_TwistInputs */

const en_solid_bright_haddock_twist = /** @type {(inputs: Solid_Bright_Haddock_TwistInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Date of results`)
};

const de_solid_bright_haddock_twist = /** @type {(inputs: Solid_Bright_Haddock_TwistInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datum der Ergebnisse`)
};

/**
* | output |
* | --- |
* | "Date of results" |
*
* @param {Solid_Bright_Haddock_TwistInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const solid_bright_haddock_twist = /** @type {((inputs?: Solid_Bright_Haddock_TwistInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Solid_Bright_Haddock_TwistInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_solid_bright_haddock_twist(inputs)
	return de_solid_bright_haddock_twist(inputs)
});